import instanceQuery from 'graphql/queries/purchases/PurchaseConfigQuery.graphql';
import defaultQuery from 'graphql/queries/purchases/PurchaseConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/purchases/PurchaseConfigMutation.graphql';
import fragment from 'graphql/fragments/purchases/PurchaseConfigFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const PurchaseConfig: EntityType = {
  type: 'PurchaseConfig',
  title: 'Purchase Order Configuration',
  formTitle: 'Purchase Order Configuration',
  formUrl: '/Purchasing/PurchaseConfig/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'PURCHASE_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default PurchaseConfig;
